export const SUPPORTED_LANGUAGE = ['en', 'fr', 'es', 'de', 'en-US'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGE)[number];
